import { BANNER_TYPE_TO_FOLDER } from '../types/banner/folder-mapping';

const formatSuffix = (suffix: string): string => {
  return suffix
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getFolderName = (folderPath: string): string => {
  if (!folderPath || folderPath === '') {
    return '';
  }

  // 1. Buscar mapping exacto
  if (BANNER_TYPE_TO_FOLDER[folderPath as keyof typeof BANNER_TYPE_TO_FOLDER]) {
    return BANNER_TYPE_TO_FOLDER[folderPath as keyof typeof BANNER_TYPE_TO_FOLDER];
  }

  // 2. Si tiene sufijo (contiene más de un "/"), extraer y formatear el último segmento
  const parts = folderPath.split('/');
  const lastPart = parts[parts.length - 1];
  return formatSuffix(lastPart);
};
